/**
 * @param {React.SVGProps<SVGSVGElement>} props
 */
const ArrowRight = (props) => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" stroke="#3A3B35" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.625 1.375L5.375 5.875L1.625 10.375" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ArrowRight;